export default __webpack_public_path__ + "static/media/gallery_02.01e8a13e.jpg";